import $ from 'jquery';

export function confidentiality() { 
    if($(".form__input-item.checkbox .checkbox__text .checkbox__link").length > 0)
    {
        $(".form__input-item.checkbox .checkbox__text .checkbox__link").attr("target", "_blank");
    }
    if($("body").hasClass("home"))
    {
        if($(".popup-thx__btn").length > 0) {
            $(".popup-thx__btn").attr("href", "javascript:void(0)");
            $(".popup-thx__btn").on("click", function() {
                if($(".popup.popup-thx").length > 0)
                {
                    const bodyOverflow = $('body');
                    $(".popup.popup-thx").removeClass("active");
                    bodyOverflow.removeClass('overflow-thx');
                }
            });
        }
        
    }
}


// WEBPACK FOOTER //
// app/scripts/components/confidentiality.js